import component from '../component';

export default component('MuiListItemText', {
  defaultProps: {
    disableTypography: true,
  },
});
